import React, { useEffect } from 'react'
import '../styles/shownotesscreen.css'

import Nav from '../components/Nav'
import Footer from '../components/Footer'

import { useSearchParams } from "react-router-dom";

import woc2025 from '../assets/documents/Widows_of_Cradock.pdf';
import no2 from '../assets/documents/Wa_Bobedi.pdf';


const ShownotesScreen = () => {
    const [searchParams] = useSearchParams();
    const showNotesName = searchParams.get("name") || "widows-of-cradock" 
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    useEffect(() => {
        document.title = `Jodorry | Show Notes | ${showNotesName}`;
    }, [showNotesName]);


    const show_note = {
        "widows-of-cradock": {
            shownote: "Widows of Cradock",
            file: woc2025
        },
        "wa-bobedi": {
            shownote: "Wa Bobedi",
            file: no2
        }
    }

    return (
        <>
            <Nav />
            <section className='shownotesscreen-container'>
                <div className='shownotes-container'>
                    {isMobile ? (
                          <a href={show_note[showNotesName].file} target="_blank" rel="noopener noreferrer">
                                Open {show_note[showNotesName].shownote} show notes (PDF)
                          </a>
                        ) : (
                        <iframe
                            title = {show_note[showNotesName].shownote}
                            src={show_note[showNotesName].file}
                        />
                    )}
                </div>
            </section>
            <Footer />
        </>
    )
}

export default ShownotesScreen